import React from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "store/index";
import { NotificationTypes, showNotification } from "store/notifications/slice";

import { ReactComponent as CopyIcon } from "assets/icons/copy-icon.svg";

import styles from "./CopyToClipboard.module.scss";

type Props = {
  text: string;
  className?: string;
  notificationMessage?: string;
};

const CopyToClipboard: React.FC<Props> = ({
  text,
  className,
  notificationMessage = text,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!text) {
      return;
    }

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      dispatch(
        showNotification({
          title: t("copied"),
          message: notificationMessage,
          type: NotificationTypes.success,
        }),
      );
    } catch {
      dispatch(
        showNotification({
          title: t("error"),
          message: t("copyError"),
          type: NotificationTypes.error,
        }),
      );
    }
  };

  return (
    <button
      type="button"
      className={`${styles.copyBtn} ${className ?? ""}`}
      onClick={handleCopy}
      onMouseDown={(e) => e.stopPropagation()}
      title={t("copy")}
      aria-label={t("copy")}
    >
      <CopyIcon className={styles.icon} />
    </button>
  );
};

export default CopyToClipboard;
